import React, { Component } from 'react';

class Disclaimers extends Component { 
  render() {
    const { view } = this.props;
    return (
      <>
      {view === 'propiedad-intelectual' &&
        <div className="propiedad-intelectual mt-4 mb-3">
        <p className="mb-0 small text-muted"><i>The intellectual property on Mind Patterns and Thinking Talents in My True Advance is drawn from source material from the books <strong>Collaborative Intelligence</strong> and <strong>Reconcilable Differences</strong> by Dawna Markova, Ph.D. and Angie McArthur, published by Spiegel & Grau, an imprint of Random House, a division of Random House, Inc. Copyright © 2015, 2017 by Dawna Markova and Angie McArthur. All right reserved.</i></p></div>
      }
      {view === 'copyright' &&
        <div className="propiedad-intelectual mt-4 mb-3">
        <p className="mb-0 small text-muted"><i>This material is excerpted from the books <strong>Collaborative Intelligence</strong> and <strong>Reconcilable Differences</strong> by Dawna Markova and Angie McArthur. Copyright © 2015, 2017 by Dawna Markova and Angie McArthur. Reprinted by arrangement with Spiegel & Grau, an imprint of Random House, a division of Random House, Inc. All right reserved.</i></p></div>
      }
      </>
    );
  }
}

export default Disclaimers;
